module.exports = __webpack_public_path__ + "img/hero_image_newsflashes.d460639.jpg";